import { useEffect } from "react";

/**
 * Sets the browser tab title while the calling component is mounted, restoring
 * whatever the title was before on unmount.
 * @param title the title to show; pass null/undefined/"" to leave the current
 *  title unchanged (e.g. while the page's data is still loading)
 * @returns void
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;

    const previousTitle = document.title;
    document.title = title;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
